import { render, staticRenderFns } from "./widgets_list.vue?vue&type=template&id=5787b278&scoped=true&"
import script from "./widgets_list.vue?vue&type=script&lang=js&"
export * from "./widgets_list.vue?vue&type=script&lang=js&"
import style0 from "./widgets_list.vue?vue&type=style&index=0&id=5787b278&scoped=true&lang=stylus&"
import style1 from "./widgets_list.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787b278",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fwidgets%2Fwidgets_list.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./widgets_list.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports